import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect:'/home'
  },
  {
    path: "/home",
    name: "home",
    component: ()=>import('@/views/home.vue'),
  },
  {
    path: "/news",
    name: "news",
    component: ()=>import('@/views/news.vue'),
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: ()=>import('@/views/newsDetail.vue'),
  },
  {
    path: "/about",
    name: "about",
    component: ()=>import('@/views/about.vue'),
  },
  {
    path: "/contact",
    name: "contact",
    component: ()=>import('@/views/contact.vue'),
  },
  {
    path: "/xietong",
    name: "xietong",
    component: ()=>import('@/views/project/xietong.vue'),
  },
  {
    path: "/chanping",
    name: "chanping",
    component: ()=>import('@/views/project/chanping.vue'),
  },
  {
    path: "/sn300",
    name: "sn300",
    component: ()=>import('@/views/project/productA.vue'),
  },
  {
    path: "/sn200",
    name: "sn200",
    component: ()=>import('@/views/project/productB.vue'),
  },
  {
    path: "/ps100",
    name: "ps100",
    component: ()=>import('@/views/project/productC.vue'),
  },
  {
    path: "/ps200",
    name: "ps200",
    component: ()=>import('@/views/project/productD.vue'),
  },
  {
    path: "/fuwu",
    name: "fuwu",
    component: ()=>import('@/views/fuwu.vue'),
  },
  {
    path: "/news1",
    name: "news1",
    component: ()=>import('@/views/project/news1.vue'),
  },
  {
    path: "/news2",
    name: "news2",
    component: ()=>import('@/views/project/news2.vue'),
  },
  {
    path: "/news3",
    name: "news3",
    component: ()=>import('@/views/project/news3.vue'),
  },
  {
    path: "/news4",
    name: "news4",
    component: ()=>import('@/views/project/news4.vue'),
  },
  {
    path: "/mobile/home",
    name: "mobileHome",
    component: ()=>import('@/views/mobile/home.vue'),
  },
  {
    path: "/mobile/xietong",
    name: "mobileXietong",
    component: ()=>import('@/views/mobile/xietong.vue'),
  },
  {
    path: "/mobile/chanping",
    name: "mobileChanping",
    component: ()=>import('@/views/mobile/chanping.vue'),
  },
  {
    path: "/mobile/about",
    name: "mobileAbout",
    component: ()=>import('@/views/mobile/about.vue'),
  },
  {
    path: "/mobile/fuwu",
    name: "mobileFuwu",
    component: ()=>import('@/views/mobile/fuwu.vue'),
  },
  {
    path: "/mobile/contact",
    name: "mobileContact",
    component: ()=>import('@/views/mobile/contact.vue'),
  },
  {
    path: "/mobile/productA",
    name: "mobileProductA",
    component: ()=>import('@/views/mobile/productA.vue'),
  },
  {
    path: "/mobile/productB",
    name: "mobileProductB",
    component: ()=>import('@/views/mobile/productB.vue'),
  },
  {
    path: "/mobile/productC",
    name: "mobileProductC",
    component: ()=>import('@/views/mobile/productC.vue'),
  },
  {
    path: "/mobile/productD",
    name: "mobileProductD",
    component: ()=>import('@/views/mobile/productD.vue'),
  },
  {
    path: "/mobile/news1",
    name: "mobileNews1",
    component: ()=>import('@/views/mobile/news1.vue'),
  },
  {
    path: "/mobile/news2",
    name: "mobileNews2",
    component: ()=>import('@/views/mobile/news2.vue'),
  },
  {
    path: "/mobile/news3",
    name: "mobileNews3",
    component: ()=>import('@/views/mobile/news3.vue'),
  },
  {
    path: "/mobile/news4",
    name: "mobileNews4",
    component: ()=>import('@/views/mobile/news4.vue'),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
